export enum CaseEnum {
  PAID = 'paid',
  FREE = 'free',
  PAID_FREE = 'paid-free',
  INIT = 'INIT',
}
export enum ProfileEnum {
  BRONZE = 'bronze',
  SILVER = 'silver',
  GOLD = 'gold',
  PLATINUM = 'platinum',
  DIAMOND = 'diamond',
}

// Case Category IDs
export const FREE_CASE_CATEGORY_ID = '26';
export const EVENT_CATEGORY_ID = '19';
